import axios from 'axios'

export default function (context) {
    context.state.load = true;
    axios.get('/tourclient/api/wiki/get')
        .then(
            d => {
                if (d.data) {
                    context.commit('set', d.data);

                } else {
                    context.commit('error', 'Не получилось получить данные');
                }
                context.state.load = false;
            }
        ).catch(d => {
        context.state.load = false;
        context.commit('error', {status: d.status}, {root: true});
    });
}
